/* ================================================================
   ContextOS — i18n  (English / Français québécois)
   Default: French. Toggle persists in localStorage.
   ================================================================ */

type Lang = 'en' | 'fr';
type Translations = Record<string, string>;

(function () {

    const STRINGS: Record<Lang, Translations> = {

        en: {
            statContactOne: 'contact',
            nextStepRequired: 'Enter a next step before choosing its due date.',
            removeField: 'Remove field',
            closeDialog: 'Close',
            switchLanguage: 'Switch language',
            askQuestion: 'Ask a question about your contacts',
            saveApiKey: 'Save API key',
            apiKeyLabel: 'Gemini API key',
            completeNextStep: 'Mark next step complete',
            restoreBackup: 'Merge JSON backup',
            restoreHint: 'Merge {n} contacts and their visit history. Existing contacts are kept; conflicting IDs become separate contacts. Your current profile is kept.',
            restoreSuccess: '{n} contacts restored. Existing data kept.',
            storageError: 'Could not save or load data on this device. Keep your input and try again; check browser storage space.',
            draftError: 'Draft could not be saved. Keep this window open and try again.',
            dictError: 'Dictation could not start or stopped unexpectedly. Check microphone permission or type your notes.',
            aiPrivacy: 'When you ask Gemini, your question, profile, contact details, recent visit notes and open next steps are sent to Google. Core contact and visit features stay on this device.',
            dictPrivacy: 'Dictation uses your browser’s speech service and may send audio to its provider.',
            skipToMain: 'Skip to contacts',
            appTitle: 'ContextOS · always prepared',
            /* header */
            tagline:              'always prepared',
            langToggle:           'FR',

            /* add contact panel */
            panelNewContact:      'New contact',
            placeholderName:      'Full name',
            btnSave:              'Save contact',

            /* custom fields */
            defaultFieldCompany:  'Company',
            addFieldPlaceholder:  'New field label',
            btnAddField:          '+ Add field',
            fieldRemove:          '×',

            /* import */
            btnImportList:        'Import',
            panelImport:          'Import contacts',
            importHint:           'Upload a CSV, Excel or ContextOS JSON backup',
            importDropLabel:      'Choose file',
            importMapHint:        'Match each column to a field',
            importSkip:           'Skip',
            importNameCol:        'Name (required)',
            importNewField:       'New: ',
            importPreview:        'Preview ({n} rows)',
            importMore:           '...and {n} more',
            btnImport:            'Import',
            btnCancel:            'Cancel',
            importError:          'Could not read file. Use a valid CSV, Excel or ContextOS backup under 10 MB.',
            importNoName:         'Please map a column to the Name field.',
            importSuccess:        '{n} contacts imported!',

            /* contact list */
            panelPeople:          'Your people',
            emptyTitle:           'No contacts yet',
            emptyHint:            'Add your first person above',
            searchPh:             'Search contacts…',
            searchAria:           'Search contacts',
            searchNoResults:      'No matching contacts.',
            statContacts:         'contacts',
            statVisitOne:         'visit this week',
            statVisitsWeek:       'visits this week',
            statDue:              'overdue',
            dueTag:               'Overdue',
            dueDaysUnit:          'd',

            /* contact detail */
            btnLogVisit:          'Log visit',
            btnPrepCard:          'Prep card',
            panelHistory:         'Visit history',
            timelineEmpty:        'No visits logged yet',

            /* prep card modal */
            prepBrief:            'PREP BRIEF',

            /* onboarding interview */
            obTitle:    'Let\'s get acquainted',
            obSubtitle: 'A few quick questions so I can help you better.',
            obStart:    'Let\'s go →',
            obSkipAll:  'Skip for now',
            obSkip:     'Skip',
            obNext:     'Next →',
            obFinish:   'Finish',
            obDone:     'Perfect. I know you a little better now.',
            obEdit:     'Edit profile',
            obQ1:       'What should I call you?',
            obQ1Ph:     'Marc, Alex, Coach…',
            obQ2:       'What industry do you work in?',
            obQ2Ph:     'Lubricants, pharma, food service…',
            obQ3:       'What are your main professional goals?',
            obQ3Ph:     'Grow my territory 20%, retain top clients…',
            obQ4:       'What do you enjoy most about your work?',
            obQ4Ph:     'Building relationships, closing deals…',
            obQ5:       'What do you find most challenging or frustrating?',
            obQ5Ph:     'Admin tasks, prospecting cold leads…',
            obQ6:       'How do you prefer my answers? Short & direct, or detailed?',
            obQ6Ph:     'Short and direct / Detailed and nuanced…',
            obQ7:       'Anything else I should know about you?',
            obQ7Ph:     'I prefer facts over small talk…',

            /* AI insights panel */
            panelInsights:        'Intelligence',
            insightPlaceholder:   'Ask anything about your clients...',
            insightLoading:       'Analyzing...',
            insightNoKey:         'Add a Gemini API key below to unlock AI insights.',
            insightNoContacts:    'Add some contacts first.',
            insightError:         'Could not reach AI. Check your API key.',
            keyConfigured:        'Key saved — paste a new one to replace',
            geminiKeyPh:          'Paste Gemini API key (AIza...)',
            btnSaveKey:           '✓',
            quickPrompt1Label:    'Prioritize',
            quickPrompt1Full:     'Who should I prioritize visiting this week, and why?',
            quickPrompt2Label:    'Opportunities',
            quickPrompt2Full:     'What are the top growth opportunities in my client base?',
            quickPrompt3Label:    'Follow up',
            quickPrompt3Full:     'Which clients are overdue for a visit and need follow-up?',

            /* dynamic — used by app.ts via window.t() */
            never:                'never',
            lastPrefix:           'last: ',
            noNotes:              '(no notes)',
            alertNameRequired:    'Please enter a name.',
            logPrompt:            'Notes about this visit:',
            noInteractions:       'First meeting. Make a great impression!',
            lastConversation:     'Last conversation',
            previous:             'Previous',

            /* visit sheet */
            visitNotesLabel:      'Notes',
            visitNotesPh:         'What you discussed, what mattered…',
            outcomeLabel:         'Outcome',
            outcomeGood:          'Good',
            outcomeNeutral:       'Neutral',
            outcomeTense:         'Tense',
            nextStepLabel:        'Next step',
            nextStepPh:           'e.g. send the quote…',
            nextStepDueAria:      'Due date (optional)',
            btnSaveVisit:         'Save visit',
            draftHint:            'Draft kept on this device',
            dictStart:            'Dictate',
            dictStop:             'Stop dictation',

            /* this-week plan */
            planTitle:            'This week',
            planLateTag:          'Late',
            planMore:             '+ {n} more',

            /* edit / delete contact */
            editContact:          'Edit contact',
            editBtnAria:          'Edit contact',
            cadenceLabel:         'Visit cadence',
            cadenceWeekly:        'Weekly',
            cadenceBiweekly:      'Every 2 weeks',
            cadenceTriweekly:     'Every 3 weeks',
            cadenceMonthly:       'Monthly',
            cadenceBimonthly:     'Every 2 months',
            cadenceQuarterly:     'Quarterly',
            btnDeleteContact:     'Delete contact',
            btnDeleteConfirm:     'Confirm deletion',

            /* export */
            exportJson:           'JSON backup',
            exportCsv:            'Export CSV',
            exportColName:        'Name',
            importSuccessDup:     '{n} contacts imported · {m} duplicates skipped',

            locale:               'en-US',
        },

        fr: {
            statContactOne: 'contact',
            nextStepRequired: 'Indiquez une prochaine étape avant de choisir son échéance.',
            removeField: 'Retirer le champ',
            closeDialog: 'Fermer',
            switchLanguage: 'Changer de langue',
            askQuestion: 'Poser une question sur vos contacts',
            saveApiKey: 'Enregistrer la clé API',
            apiKeyLabel: 'Clé API Gemini',
            completeNextStep: 'Marquer la prochaine étape terminée',
            restoreBackup: 'Fusionner la sauvegarde JSON',
            restoreHint: 'Fusionner {n} contacts et leur historique de visites. Les contacts existants sont conservés; les identifiants en conflit créent des contacts distincts. Votre profil actuel est conservé.',
            restoreSuccess: '{n} contacts restaurés. Données existantes conservées.',
            storageError: 'Impossible de sauvegarder ou de charger les données sur cet appareil. Conservez votre saisie et réessayez; vérifiez l’espace de stockage du navigateur.',
            draftError: 'Impossible de sauvegarder le brouillon. Gardez cette fenêtre ouverte et réessayez.',
            dictError: 'La dictée n’a pas démarré ou s’est interrompue. Vérifiez l’autorisation du microphone ou saisissez vos notes.',
            aiPrivacy: 'Lorsque vous interrogez Gemini, votre question, votre profil, les détails des contacts, les notes récentes et les prochaines étapes ouvertes sont envoyés à Google. Les contacts et les visites restent sur cet appareil.',
            dictPrivacy: 'La dictée utilise le service vocal de votre navigateur et peut transmettre l’audio à son fournisseur.',
            skipToMain: 'Aller aux contacts',
            appTitle: 'ContextOS · toujours prêt',
            /* header */
            tagline:              'toujours prêt',
            langToggle:           'EN',

            /* add contact panel */
            panelNewContact:      'Nouveau contact',
            placeholderName:      'Nom complet',
            btnSave:              'Enregistrer',

            /* custom fields */
            defaultFieldCompany:  'Compagnie',
            addFieldPlaceholder:  'Nom du nouveau champ',
            btnAddField:          '+ Ajouter champ',
            fieldRemove:          '×',

            /* import */
            btnImportList:        'Importer',
            panelImport:          'Importer des contacts',
            importHint:           'Choisissez un fichier CSV, Excel ou une sauvegarde JSON ContextOS',
            importDropLabel:      'Choisir un fichier',
            importMapHint:        'Associez chaque colonne à un champ',
            importSkip:           'Ignorer',
            importNameCol:        'Nom (requis)',
            importNewField:       'Nouveau\u00a0: ',
            importPreview:        'Aperçu ({n} lignes)',
            importMore:           '...et {n} de plus',
            btnImport:            'Importer',
            btnCancel:            'Annuler',
            importError:          'Impossible de lire le fichier. Utilisez un CSV, un fichier Excel ou une sauvegarde ContextOS valide de moins de 10 Mo.',
            importNoName:         'Veuillez associer une colonne au champ Nom.',
            importSuccess:        '{n} contacts importés\u00a0!',

            /* contact list */
            panelPeople:          'Vos contacts',
            emptyTitle:           'Aucun contact pour l\'instant',
            emptyHint:            'Ajoutez votre premier contact ci-dessus',
            searchPh:             'Rechercher un contact…',
            searchAria:           'Rechercher un contact',
            searchNoResults:      'Aucun contact ne correspond.',
            statContacts:         'contacts',
            statVisitOne:         'visite cette semaine',
            statVisitsWeek:       'visites cette semaine',
            statDue:              'à revoir',
            dueTag:               'À revoir',
            dueDaysUnit:          'j',

            /* contact detail */
            btnLogVisit:          'Consigner une visite',
            btnPrepCard:          'Fiche prépa',
            panelHistory:         'Historique',
            timelineEmpty:        'Aucune visite enregistrée',

            /* prep card modal */
            prepBrief:            'FICHE PRÉPA',

            /* onboarding interview */
            obTitle:    'Faisons connaissance',
            obSubtitle: 'Quelques questions rapides pour mieux vous aider.',
            obStart:    'Commencer \u2192',
            obSkipAll:  'Passer pour l\u2019instant',
            obSkip:     'Passer',
            obNext:     'Suivant \u2192',
            obFinish:   'Terminer',
            obDone:     'Parfait. Je vous connais d\u00e9j\u00e0 un peu mieux.',
            obEdit:     'Modifier mon profil',
            obQ1:       'Comment puis-je vous appeler\u00a0?',
            obQ1Ph:     'Marc, Maude, Coach\u2026',
            obQ2:       'Dans quelle industrie travaillez-vous\u00a0?',
            obQ2Ph:     'Lubrifiants, pharma, restauration\u2026',
            obQ3:       'Quels sont vos principaux objectifs professionnels\u00a0?',
            obQ3Ph:     'Augmenter mes ventes de 20\u00a0%, fid\u00e9liser mes grands comptes\u2026',
            obQ4:       'Qu\u2019est-ce que vous aimez le plus dans votre travail\u00a0?',
            obQ4Ph:     'Le contact humain, n\u00e9gocier, conseiller\u2026',
            obQ5:       'Qu\u2019est-ce que vous trouvez le plus difficile ou frustrant\u00a0?',
            obQ5Ph:     'La paperasse, prospecter \u00e0 froid\u2026',
            obQ6:       'Comment pr\u00e9f\u00e9rez-vous mes r\u00e9ponses\u00a0? Courtes et directes, ou d\u00e9taill\u00e9es\u00a0?',
            obQ6Ph:     'Courtes et directes / D\u00e9taill\u00e9es et nuanc\u00e9es\u2026',
            obQ7:       'Y a-t-il autre chose que je devrais savoir sur vous\u00a0?',
            obQ7Ph:     'Je pr\u00e9f\u00e8re les faits, pas de bavardage\u2026',

            /* AI insights panel */
            panelInsights:        'Intelligence',
            insightPlaceholder:   'Posez une question sur vos clients\u00a0...',
            insightLoading:       'Analyse en cours\u00a0...',
            insightNoKey:         'Ajoutez une cl\u00e9 API Gemini ci-dessous pour activer l\u2019IA.',
            insightNoContacts:    'Ajoutez d\u2019abord des contacts.',
            insightError:         'Impossible de contacter l\u2019IA. V\u00e9rifiez votre cl\u00e9 API.',
            keyConfigured:        'Cl\u00e9 enregistr\u00e9e\u00a0\u2014 collez-en une nouvelle pour la remplacer',
            geminiKeyPh:          'Cl\u00e9 API Gemini (AIza...)',
            btnSaveKey:           '\u2713',
            quickPrompt1Label:    'Prioriser',
            quickPrompt1Full:     'Qui dois-je prioriser cette semaine, et pourquoi\u00a0?',
            quickPrompt2Label:    'Opportunit\u00e9s',
            quickPrompt2Full:     'Quelles sont les meilleures opportunit\u00e9s de croissance dans ma client\u00e8le\u00a0?',
            quickPrompt3Label:    'Relancer',
            quickPrompt3Full:     'Quels clients sont en attente de visite et doivent \u00eatre relanc\u00e9s\u00a0?',

            /* dynamic — used by app.ts via window.t() */
            never:                'jamais',
            lastPrefix:           'dernière\u00a0: ',   /* non-breaking space before colon — Quebec style */
            noNotes:              '(sans notes)',
            alertNameRequired:    'Veuillez entrer un nom.',
            logPrompt:            'Notes sur cette visite\u00a0:',
            noInteractions:       'Première rencontre. Faites bonne impression\u00a0!',
            lastConversation:     'Dernière conversation',
            previous:             'Auparavant',

            /* visit sheet */
            visitNotesLabel:      'Notes',
            visitNotesPh:         'Ce dont vous avez parlé, ce qui compte…',
            outcomeLabel:         'Résultat',
            outcomeGood:          'Bonne',
            outcomeNeutral:       'Neutre',
            outcomeTense:         'Tendue',
            nextStepLabel:        'Prochaine étape',
            nextStepPh:           'Ex. : envoyer la soumission…',
            nextStepDueAria:      'Échéance (optionnel)',
            btnSaveVisit:         'Consigner',
            draftHint:            'Brouillon conservé sur cet appareil',
            dictStart:            'Dicter',
            dictStop:             'Arrêter la dictée',

            /* this-week plan */
            planTitle:            'Cette semaine',
            planLateTag:          'En retard',
            planMore:             '+ {n} autres',

            /* edit / delete contact */
            editContact:          'Modifier le contact',
            editBtnAria:          'Modifier le contact',
            cadenceLabel:         'Rythme de visite',
            cadenceWeekly:        'Hebdomadaire',
            cadenceBiweekly:      'Aux 2 semaines',
            cadenceTriweekly:     'Aux 3 semaines',
            cadenceMonthly:       'Mensuel',
            cadenceBimonthly:     'Aux 2 mois',
            cadenceQuarterly:     'Trimestriel',
            btnDeleteContact:     'Supprimer le contact',
            btnDeleteConfirm:     'Confirmer la suppression',

            /* export */
            exportJson:           'Sauvegarde JSON',
            exportCsv:            'Exporter CSV',
            exportColName:        'Nom',
            importSuccessDup:     '{n} contacts importés · {m} doublons ignorés',

            locale:               'fr-CA',
        },
    };

    /* ── Core translation function ─────────────────────────── */
    let _lang: Lang = localStorage.getItem('ctx-lang') === 'en' ? 'en' : 'fr';

    window.t = function (key: string | null) {
        if (!key) return '';
        return (STRINGS[_lang] && STRINGS[_lang][key]) !== undefined
            ? STRINGS[_lang][key]
            : (STRINGS.en[key] || key);
    };

    window.getLang = function () { return _lang; };

    window.setLang = function (l: Lang) {
        _lang = l;
        localStorage.setItem('ctx-lang', l);
        document.documentElement.lang = l === 'fr' ? 'fr-CA' : 'en';
        applyStaticTranslations();

        /* Re-render dynamic content that app.ts owns */
        if (typeof window.renderAddContactForm === 'function') {
            window.renderAddContactForm();
        }
        if (typeof window.renderContactList === 'function') {
            void window.renderContactList().catch(() => { const el = document.getElementById('app-status'); if (el) el.textContent = window.t('storageError'); });
        }
        if (typeof window.currentContactId !== 'undefined' && window.currentContactId) {
            if (typeof window.showContactDetail === 'function') {
                void window.showContactDetail(window.currentContactId).catch(() => { const el = document.getElementById('app-status'); if (el) el.textContent = window.t('storageError'); });
            }
        }
        if (typeof window.renderQuickPrompts === 'function') {
            window.renderQuickPrompts();
        }
        if (typeof window.initApiKeyInput === 'function') {
            window.initApiKeyInput();
        }
    };

    /* ── Apply translations to static DOM elements ─────────── */
    function applyStaticTranslations() {
        document.title = window.t('appTitle');
        /* Text content */
        document.querySelectorAll<HTMLElement>('[data-i18n]').forEach(function (el) {
            el.textContent = window.t(el.getAttribute('data-i18n'));
        });

        /* Placeholder attributes */
        document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('[data-i18n-ph]').forEach(function (el) {
            el.placeholder = window.t(el.getAttribute('data-i18n-ph'));
        });

        /* aria-label attributes */
        document.querySelectorAll<HTMLElement>('[data-i18n-aria]').forEach(function (el) {
            el.setAttribute('aria-label', window.t(el.getAttribute('data-i18n-aria')));
        });
    }

    /* ── Run on DOM ready ───────────────────────────────────── */
    function init() {
        document.documentElement.lang = _lang === 'fr' ? 'fr-CA' : 'en';
        applyStaticTranslations();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
